import { useEffect, useEffectEvent, useRef, useState } from "react";
import SearchComponent from "../../components/SearchComponent";
import { ApiService } from "../../utils/ApiService";
import { showToast } from "../../common/Toast";
import { Avatar, formatDateTime } from "../../common/Functions";
import Pagination from "../../common/Pagination";
import CustomRangePicker from "../../components/CustomeRangePicker/CustomRangePicker";
import { capitalizeEachWord } from "../../utils/common";
import FullPageLoader from "../../common/FullPageLoader";

const WaitingList = () => {
    const [search, setSearch] = useState("");
    const [startingIndex, setStartingIndex] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pagination, setPagination] = useState({
        currentPage: 0,
        pageSize: 0,
        totalPages: 0,
        totalSubscribed: 0,
    });
    const [loading, setLoading] = useState(true);
    const [waitingList, setWaitingList] = useState([]);
    const[sendMailLoading, setSendMailLoading] = useState(false);

    const fetchWaitingList = async () => {
        try {
            const token = localStorage.getItem("auth_token")
            const res = await ApiService.get(
                `admin/email-subscription-list?search=${search}&page=${page}&limit=${limit}`,
                {},
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            )

            setWaitingList(res.emailsub)
            setPagination(res.pagination)
            setLoading(false);

        } catch (error) {
            console.log("Error fetching waiting list --> ", error)
        }
    }

    console.log("PAGINATION --> ", pagination)

    useEffect(() => {
        fetchWaitingList();
    }, [search, page])

    const handleSendEmails = async () => {
        setSendMailLoading(true)
        try {
            const token = localStorage.getItem("auth_token")
            const res = await ApiService.post(
                `admin/send-email`,
                {},
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            )
            showToast.success(res.message || "Emails sent successfully")
            console.log("res", res)
        } catch (error) {
            console.log("Error while sending emails to waiting users --> ", error)
        }finally{
            setSendMailLoading(false)
        }
    }

    const handlePagination = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPage(newPage);
        }
    }

    return (
        <>
            {loading && <FullPageLoader />}
            <div className="flex-grow bg-gray-100 px-6 w-full overflow-auto h-[90vh]">
                <div className="flex flex-row items-center mb-6 justify-between pr-2">
                    <SearchComponent search={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by email..." />
                    <button className="bg-[#8B7355] text-white shadow-[0_3px_9px_rgba(0,0,0,0.28)] hover:bg-[#8d6534] p-3 rounded-md"
                    onClick={handleSendEmails}
                    disabled={sendMailLoading}
                    >{sendMailLoading ? "Sending..." : "Send Emails"}</button> 
                </div>

                {<>
                    <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
                        <table className="w-full text-center">
                            <thead className="bg-gray-200 text-m text-black">
                                <tr>
                                    <th className="p-4 text-left font-normal">Date & Time</th>
                                    <th className="p-4 text-left font-normal">Email</th>
                                    <th className="p-4 text-left font-normal">Role</th>
                                    <th className="p-4 text-left font-normal">Type</th>
                                    {/* <th className="p-4 text-left font-normal">Payout Id</th>
                                    <th className="p-4 text-left font-normal">Status</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {waitingList.length ? (
                                    waitingList.map((list) => (
                                        <tr
                                            key={list._id}
                                            className="border-t hover:bg-gray-50 cursor-pointer"
                                            >
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{formatDateTime(list.createdAt)}</td>
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{list.email}</td>
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{capitalizeEachWord(list.joinType[0])}</td>
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">
                                                {
                                                    list.type === "GATHER_APP" ? "App" : "Subscription"
                                                }
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            className="text-center py-10 text-gray-500"
                                        >
                                            No results found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>

                    </div>
                    {
                        pagination.totalPages > 1 && (
                        <Pagination
                            page={page}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalSubscribed}
                            limit={limit}
                            onPageChange={(newPage) => handlePagination(newPage)}
                        />
                        )
                    }
                </>}
            </div>
            
        </>
    )
}
export default WaitingList;